export const columnFlexStyle = (width) => {
    if (typeof width !== 'string')
        return { flex: '1 1 0%', minWidth: '240px' };
    const trimmed = width.trim();
    if (!trimmed.length)
        return { flex: '1 1 0%', minWidth: '240px' };
    if (trimmed.endsWith('fr')) {
        const num = parseFloat(trimmed);
        const grow = Number.isFinite(num) && num > 0 ? num : 1;
        return { flex: `${grow} ${grow} 0%`, minWidth: '240px' };
    }
    if (trimmed.endsWith('%'))
        return { flex: '0 0 auto', width: trimmed };
    if (trimmed.endsWith('px'))
        return { flex: '0 0 auto', width: trimmed };
    const numeric = Number(trimmed);
    if (!Number.isNaN(numeric) && numeric > 0)
        return { flex: '0 0 auto', width: `${numeric}px` };
    return { flex: '1 1 0%', minWidth: '240px' };
};
